module.exports = __webpack_public_path__ + "img/Dantam Hair 30.bc21cc38.jpg";